import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserNoticeBoardComponent } from './user-notice-board.component';

const routes: Routes = [
  {
    path: '',
    component: UserNoticeBoardComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserNoticeBoardRoutingModule {}
